import { useEffect, useState } from 'react';

import { useNavigationStore } from '../../../context/zustand/navigationStore';
import { useSlidesStore } from '../../../context/zustand/slidesStore';
import { usePorteeSlideManager, usePotree } from '../../../hooks/usePotree';
import { useToggle } from '../../../hooks/useToggle';
import { OrtoScene } from '../../../types';
import { AccordionContent, AccordionTrigger } from '../../shadcn-ui/accordion';
import Slide from './Slide';
/*
import {
  SerializableAnnotation,
  AnnotationPotreeObject
} from '../../../types';
import { Dialog } from '../../shadcn-ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../shadcn-ui/dropdown-menu';
import AnnotationViewer from '../annotations/AnnotationViewer';
import { OrtoSceneHelper } from '../../../utils/OrtoSceneHelper';
*/

interface SceneSlidesProps {
  order: string;
  slides: OrtoScene[];
}

const Presentation: React.FC<SceneSlidesProps> = ({
  slides,
  order: presentationOrder,
}) => {

  const { project } = usePotree();
  const potreeSlideManager = usePorteeSlideManager();
  const { potreeDisplayMode } = useToggle();

  const state = useSlidesStore();
  const { activeSlide } = state;

  type AnnotationDialogs = 'editDialog' | 'maximizeDialog';
  const { enableKeyboardEvents, disableKeyboardEvents } = useNavigationStore();
  const [openDialog, setOpenDialog] = useState<AnnotationDialogs | null>(null);

/*
  let annotationTmp = {
  	uuid: '123',
    title: 'test',
    description: 'description',
    description_short: 'description_short',
    descriptionVisible: true,
    position: [0,0,0],
    cameraPosition: [0,0,0],
    cameraTarget: [0,0,0]
	};

  const [editedAnnotation, setEditedAnnotation] =
    useState<SerializableAnnotation>(
      OrtoSceneHelper.createAnnotationsData(annotationTmp)
    );
*/    
  const _openDialog = (dialog: AnnotationDialogs) => {
    setOpenDialog(dialog);
    disableKeyboardEvents();
  };

  const _closeDialog = () => {
    setOpenDialog(null);
    enableKeyboardEvents();
  };  
  
	let annotationIndex = -1;
	const animationTimer = Date.now();
  
	const getAnnotations = () => {

		let anno = Array.from(document.querySelectorAll('.annotation')).filter(el => {
			const zIndex = window.getComputedStyle(el).zIndex;
	    	return zIndex !== 'auto';
		});	
		
		console.log('anno',anno);	
		
		return anno;
	
	}

	let annotations = getAnnotations();
	
	const ongoingTransition = () => {
		return (Date.now() - animationTimer) < 1500 ? true:false;
	}
    
  const keyboardEvents = useNavigationStore((state) => state.keyboardEvents);
  
  let imgIndex = 0;

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {    
      const displayModeScenes =
        project?.field_scenes[potreeDisplayMode]?.scenes;
		
      if (!ongoingTransition() && (e.key === 'ArrowRight') && displayModeScenes && !document.getElementsByClassName('image_enlarged').length) {
        e.preventDefault();
		
		annotations = getAnnotations();
		//console.log('ArrowRight',annotations);

        annotationIndex++;
        if (annotations && annotations.length > 0) {
        	if (annotationIndex > annotations.length - 1) annotationIndex = 0;
        	let annoEl = annotations[annotationIndex];
        	let el: HTMLElement = annoEl.getElementsByClassName('annotation-title')[0] as HTMLElement;
			if (el) el.click();
        }
      	// console.log(annotationIndex);
      }
      
      if (!ongoingTransition() && (e.key === 'ArrowLeft') && displayModeScenes && !document.getElementsByClassName('image_enlarged').length) {
        e.preventDefault();

		annotations = getAnnotations();
		
		//console.log('ArrowLeft',annotations);

        annotationIndex--;
        if (annotations && annotations.length > 0) {
        	if (annotationIndex < 0) annotationIndex = annotations.length - 1;
        	let annoEl = annotations[annotationIndex];
        	let el: HTMLElement = annoEl?.getElementsByClassName('annotation-title')[0] as HTMLElement;
        	//console.log(el);
			if (el) el.click();
        }

      	// console.log(annotationIndex);
      }

      if (((e.key === ' ') || (e.key === 'ArrowLeft' && document.getElementsByClassName('image_enlarged').length > 0) || (e.key === 'ArrowRight' && document.getElementsByClassName('image_enlarged').length > 0)) && displayModeScenes) {
        
        e.preventDefault();

		annotations = getAnnotations();
		
		if (document.getElementsByClassName('image_enlarged').length > 0) {

			if (false && e.key === ' ') {
/*
				let eImgs = document.getElementsByClassName('image_enlarged');
				for (let n=0;n<eImgs.length; n++) {
					eImgs[n].remove();
				}
*/			
			} else {
			
				if (annotations && annotations.length > 0) {
	
					let annoEl = annotations[annotationIndex];
					let adc = annoEl.getElementsByClassName('annotation-description-content')[0] as HTMLElement;
										
					let imgList = adc.getElementsByTagName('img'); 
	
					if (imgList && imgList.length > 0 ) {
	
						let eImgs = document.getElementsByClassName('image_enlarged');
						for (let n=0;n<eImgs.length; n++) {
							eImgs[n].remove();
						}
	
						if (e.key === 'ArrowRight' || e.key === ' ') imgIndex++;
						else if (e.key === 'ArrowLeft') imgIndex--;
						
						if (imgIndex < 0) imgIndex = imgList.length - 1;
						else if (imgIndex > imgList.length - 1) imgIndex = 0;
						//console.log('imgIndex',imgIndex);
	
						let img = imgList[imgIndex] as HTMLElement;
						let imgClone = img.cloneNode(true);
						
						let wrapper = document.createElement( 'div' );
						wrapper.appendChild(imgClone);
						let root = document.getElementById('root');
						if (root) root.appendChild(wrapper);
						
						wrapper.setAttribute('class','image_enlarged');
						wrapper.setAttribute('onclick','this.remove()');
	
					}
					
				}

			}

		} else {

			imgIndex = 0;

			if (annotationIndex > -1 && annotations && annotations.length > 0) {

				let annoEl = annotations[annotationIndex];
				let adc = annoEl.getElementsByClassName('annotation-description-content')[0] as HTMLElement;
				let imgList = adc.getElementsByTagName('img'); 
				
				if (imgList.length > 0) {
					//console.log('imgList',imgList);
					
					let img = imgList[0] as HTMLElement;
					let imgClone = img.cloneNode(true);
					
					let wrapper = document.createElement( 'div' );
					wrapper.appendChild(imgClone);
					let root = document.getElementById('root');
					if (root) root.appendChild(wrapper);
					
					wrapper.setAttribute('class','image_enlarged');
					wrapper.setAttribute('onclick','this.remove()');					        	
				}
			}
		}

      }

		if ((e.key === 'Escape') && displayModeScenes) {
        	e.preventDefault();
      		// console.log("Escape");
      		
			let eImgs = document.getElementsByClassName('image_enlarged');
			for (let n=0;n<eImgs.length; n++) {
				eImgs[n].remove();
			}
							
      	}

      if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && displayModeScenes && !document.getElementsByClassName('image_enlarged').length) {
        e.preventDefault();

        const currentIndex = displayModeScenes.findIndex(
          (scene) => scene.id === activeSlide.id
        );

        let newIndex;
        if (e.key === 'ArrowUp') {
          newIndex =
            currentIndex === 0
              ? displayModeScenes.length - 1
              : currentIndex - 1;
        } else {
          newIndex =
            currentIndex === displayModeScenes.length - 1
              ? 0
              : currentIndex + 1;
        }

        const targetScene = displayModeScenes[newIndex];
        if (targetScene) {
          potreeSlideManager.goToSlide(targetScene, potreeDisplayMode);
        }
      }
    };

    if (keyboardEvents === 'enabled') {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [
    activeSlide.id,
    potreeSlideManager,
    potreeDisplayMode,
    project?.field_scenes,
    keyboardEvents,
  ]);

  // NOTE: another hack, this time for backward compatibility of the projects
  // checks if a presentation is really a presentation or not. If not, does not wrap the slides in an accordion.
  const isPresentation =
    slides.filter((slide) => slide.label.startsWith('#')).length > 0;

    /*
		changed: nestable
	*/

    //isPresentation = false;

  if (!isPresentation) {
    return (
      <div className="flex flex-col gap-2">
        {slides.map((slide, index) => (
          <Slide
            key={`slide-${presentationOrder}-${index + 1}`}
            slide={slide}
            order={`${index + 1}`}
          />
        ))}
      </div>
    );
  }
	
  return (
    <>
      {slides.map((slide, index) => {
        if (index === 0) {
          return (
            <AccordionTrigger
              key={`slide-${presentationOrder}-${index}`}
              className="pb-2"
            >
              {/* TODO this should probably become a dedicated PresentationHeader (or so) component at some point */}
              <Slide slide={slide} order={presentationOrder} isParent />
            </AccordionTrigger>
          );
        }
        return (
          <AccordionContent
            key={`slide-${presentationOrder}-${index}`}
            className="pb-2"
          >
            <Slide slide={slide} order={`${presentationOrder}.${index}`} />

        </AccordionContent>
        );
      })}            
    </>
  );
};

export default Presentation;

